import React from 'react';


const QuoteIcon = () => {

  return (
    <svg width="44px" height="62px" viewBox="0 0 44 62" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
      <title>1. quote</title>
      <desc>Created with Sketch.</desc>
      <g id="Final-version" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g id="Logging_A_Lead_Desktop_1440_Submission_Confirmation_High_Fidelity" transform="translate(-285.000000, -804.000000)">
              <g id="01-Atoms-/-Icons-/-document-/-#333333" transform="translate(270.000000, 798.000000)">
                  <g id="document">
                      <g>
                          <polygon id="bg" fillOpacity="0" fill="#D8D8D8" points="0 0 73.9200003 0 73.9200003 73.9200003 0 73.9200003"></polygon>
                          <path d="M47.7400002,32.3400002 L26.1800001,32.3400002" id="path_1" stroke="#007C92" strokeWidth="3.08000001" strokeLinecap="round" strokeLinejoin="round"></path>
                          <path d="M47.7400002,41.5800002 L26.1800001,41.5800002" id="path_1" stroke="#007C92" strokeWidth="3.08000001" strokeLinecap="round" strokeLinejoin="round"></path>
                          <path d="M47.7400002,50.8200002 L26.1800001,50.8200002" id="path_1" stroke="#007C92" strokeWidth="3.08000001" strokeLinecap="round" strokeLinejoin="round"></path>
                          <path d="M56.9800003,20.0200001 L44.6600002,7.70000004 L21.5600001,7.70000004 L21.5599999,7.70000004 C19.0084432,7.70000004 16.9399999,9.76844335 16.9399999,12.3200001 C16.9399999,12.3200001 16.9399999,12.3200001 16.9399999,12.3200001 L16.9399999,61.6000003 L16.9399999,61.600001 C16.9399999,64.1515577 19.0084432,66.220001 21.5599999,66.220001 L52.36,66.220001 L52.3599998,66.220001 C54.9115566,66.220001 56.9800003,64.1515577 56.9800003,61.600001 L56.9800003,20.0200008 L56.9800003,20.0200001 Z" id="Shape" stroke="#007C92" strokeWidth="3.08000001" strokeLinejoin="round"></path>
                          <polyline id="Shape" stroke="#007C92" strokeWidth="3.08000001" strokeLinejoin="round" points="44.6600002 7.78855004 44.6600002 20.0200001 56.9800003 20.0200001"></polyline>
                      </g>
                  </g>
              </g>
          </g>
      </g>
  </svg>
  );
}



export default QuoteIcon;